export const czech = {
    RESPONSE_ERROR_400:
        'Během zpracování došlo k chybě, můžete se pokusit získat výstup znovu nebo kontaktujte správce aplikace.',
    RESPONSE_ERROR_401: 'Vypršela platnost stránky. Prosím přihlašte se znovu.',
    RESPONSE_ERROR_404: 'Zadaným výběrovým kritériím nevyhovují žádná data.',
    RESPONSE_ERROR_500:
        'Během zpracování došlo k chybě, můžete se pokusit získat výstup znovu nebo kontaktujte správce aplikace.',
    RESPONSE_ERROR_503: 'Server je nedostupný. Opakujte akci znova.',
    SLUZBA_NEDOSTUPNA: 'Služba je nedostupná. Opakuje akci prosím později.',

    CHYBA_NADPIS: 'Pozor, došlo k chybě',
    CHYBA_OBECNA:
        'Během zpracování došlo k chybě, můžete se pokusit získat výstup znovu nebo kontaktujte správce aplikace.',
    CHYBA_CHYBA:
        'Během zpracování došlo k chybě, můžete se pokusit získat výstup znovu nebo kontaktujte správce aplikace.',
    CHYBA_JINYUCET: 'Nemáte oprávnění pro přístup pro danou žádost.',
    CHYBA_NEPREDANEPARAMETRY: 'Nepředali jste nutné položky pro zpracování žádosti',
    CHYBA_LIMIT:
        'Váš měsíční limit pro zjišťování majetkových účtů v nezařazené evidenci byl překročen. Nové požadavky můžete zadávat od',

    NACITANI: 'Načítání...',
    STAHOVANI: 'Stahování souboru...',
    NEVALIDNI_POVINNA_POLOZKA: 'Hodnota musí být vyplněna',
    NEVALIDNI_EMAIL: 'Nevalidní e-mail',
    NEVALIDNI_EMAIL_SHODA: 'Zadané e-mailové adresy se neshodují',
    NEVALIDNI_TELEFON: "Nesprávný telefon - zadejte 9-17 znaků bez mezer, na začátku buď '+' nebo '00'",
    POKRACOVAT: 'Pokračovat',
    PREJIT_ZPET_NA_PRIHLASENI: 'Přejít zpět na přihlášení',

    JMENO_PRIJMENI: 'Jméno a příjmení',
    EMAIL: 'E-mail',
    EMAIL_CHECK: 'E-mail znovu',
    PHONE_NUMBER: 'Telefonní číslo',

    POPIS_SLUZBY: 'Popis služby',
    BANK_ID: 'BankID',
    VYPIS_Z_UCTU: 'Výpis z účtu v nezařazené evidenci',

    NEZARAZENY_UCET: 'Nezařazený účet',

    PODANI_NOVE_ZADOSTI_INFO_O_SLUZBE2:
        'Před potvrzením údajů poskytovaných prostřednictvím BankID zkontrolujte, zda poskytujete aktuální údaje, zejména emailovou adresu. Na Vámi uvedený email Vám přijde potvrzení o platbě a odkaz pro stažení vyhotoveného výpisu. ',
    PODANI_NOVE_ZADOSTI_INFO_O_SLUZBE3:
        'V případě, že není údaj o emailové adrese aktuální, odškrtněte zelený symbol pro poskytnutí tohoto údaje. V dalším kroku budete vyzvání k vyplnění aktuálního emailu. Emailovou adresu můžete také aktualizovat prostřednictvím Vašeho internetového bankovnictví.',
    PODANI_NOVE_ZADOSTI_INFO_O_SLUZBE_P1:
        'Nezařazeným účtem se rozumí účet, který byl převzat ze zaniklého Střediska cenných papírů a jehož majitel dosud neuzavřel s účastníkem centrálního depozitáře smlouvu. Služba umožňuje získat online výpis z tohoto nezařazeného účtu k aktuálnímu datu ',
    PODANI_NOVE_ZADOSTI_INFO_O_SLUZBE_P2: 'pouze jeho majiteli',
    PODANI_NOVE_ZADOSTI_INFO_O_SLUZBE_P3:
        ', který se identifikuje prostřednictvím bankovní identity a uhradí poplatek za výpis prostřednictvím online platby platební brány. Poplatek je pro službu stanoven paušálně bez ohledu na výslednou informaci (tedy zda účet existuje či nikoliv a bez ohledu na strukturu a objem cenných papírů, které jsou na účtu vedeny). V případě, že nelze Váš požadavek na službu zpracovat automaticky, budete kontaktováni pracovníky centrálního depozitáře pro další postup prostřednictvím Vašeho emailu nebo telefonu, který nám poskytnete při identifikaci přes BankID.',

    NEZARAZENY_UCET_PRIHLASENI: 'Přístup k žádosti o výpis',
    PRISTUP_K_DRIVE_PODANE_ZADOSTI:
        'Abyste mohli přistoupit ke dříve podané žádosti o výpis z nezařazeného účtu, je nutné se nejprve identifikovat pomocí BankID.',

    PRIHLASIT_SE_PPRES_BANKID: 'Přihlásit se přes BankID',

    FORMA_UHRADY1: 'Forma úhrady',
    FORMA_UHRADY2: 'On-line pomocí platební brány',
    FORMA_UHRADY: 'Forma úhrady: On-line pomocí platební brány',
    ZADOST_O_SLUZBU_K_AKTUALNIMU_DATU: 'Žádost o službu Výpis z nezařazeného účtu k aktuálnímu datu',
    ZADOST_O_SLUZBU_K_AKTUALNIMU_DATU_NU: 'Žádost o ověření majetkového účtu v nezařazené evidenci',
    ZADATEL: 'Žadatel',
    ZPET: 'Zpět',
    CELKOVA_CASTKA: 'Celková částka',
    ZADOST_BYLA_ODESLANA: 'Žádost o výpis pro Vaší osobu byla úspěšně odeslána.',
    O_ZPRACOVANI_BUDETE_INFORMOVANI: 'O zpracování žádosti budete informováni e-mailem.',
    POTVRDIT_SOUHLAS: 'Prosíme, potvrďte souhlas',
    POTVRDIT_A_ODESLAT: 'Potvrdit a odeslat',
    ZAPLATIT: 'Zaplatit',
    MOZNOST_STAHNOUT_DO: 'Výpis je možné stáhnout do',
    STAHNOUT: 'Stáhnout',
    VYPLNTE_CHYBEJICI_UDAJE: 'Vyplňte chybějící údaje',
    SHRNUTI_OBJEDNAVKY: 'Shrnutí žádosti o službu',
    VYPIS_TEXT_MAIL: 'Na Vámi uvedený email Vám přijde potvrzení o platbě a odkaz pro stažení vyhotoveného výpisu.',
    VYPIS_MAIL_INFO: 'Zde vyplněná emailová adresa nemění nastavení emailu Vašeho internetového bankovnictví',
    STAV_IDEN: 'IDEN',
    KROKY_PRO_ZISKANI_VYSTUPU: 'Podmínky získání výpisu z nezařazeného účtu online',
    KROKY_PRO_ZISKANI_VYSTUPU_NU:
        'Podmínky zjištění majetkového účtu v nezařazené evidenci pro účely dodatečného projednání dědictví',
    POTVRZENI_ZADOSTI: 'Potvrzení žádosti o službu na základě identifikace prostřednictvím BankID ',
    SOUHLAS_S_PODMINKAMI: 'Souhlas s podmínkami poskytované služby',
    ZAPLACENI_POPLATKU_KARTOU: 'Zaplacení poplatku ve výši 90 Kč',
    POSKYTNUTI_RC: 'Poskytnutí RČ prostřednictvím BankID pro vytvoření výpisu',
    STAZENI_VYPISU_A_FAKTURY: 'Stažení výpisu a faktury po opětovném ověření prostřednictvím BankID',
    SOUHLASIM_S: 'Souhlasím s ',
    PODMINKAMI_SLUZBY: 'podmínkami služby ',
    VYPIS_Z_NEZAR_UCTU_K_AKTUALNIMU_DATU: 'Výpis z nezařazeného účtu k aktuálnímu datu.',

    PODMINKY_SLUZBY: 'Podmínky poskytnutí služby Výpis z nezařazeného účtu k aktuálnímu datu online',
    PODMINKY_SLUZBY_NU:
        'Podmínky poskytnutí služby Zjištění majetkového účtu v nezařazené evidenci pro účely dodatečného projednání dědictví ',
    PODMINKY_SLUZBY_ZU:
        'Podmínky poskytnutí služby Zápis změny údajů evidovaných o majiteli nezařazeného účtu ',
    PODMINKY_P1:
        'Centrální depozitář cenných papírů, a.s., poskytne majiteli nezařazeného účtu na jeho žádost elektronický výpis z jeho účtu cenných papírů po ověření žadatele prostřednictvím bankovní identity (BankID). Výpis bude poskytnut k datu zpracování služby centrálním depozitářem. Služba není poskytována majitelům nezařazených účtů, kteří jsou právnickým osobami.',
    PODMINKY_P2:
        'Podmínkou poskytnutí služby je řádné podání žádosti a uhrazení poplatku za tuto službu předem. Poplatek lze uhradit pouze prostřednictvím platební brány použitím spotřebitelské platební karty vydané v Evropské Unii nebo pomocí platebních tlačítek. . Žadatel je povinen uhradit poplatek i v případě, že žádný majetkový účet v evidenci nezařazených účtů na jméno žadatele veden není.',
    PODMINKY_P3:
        'Žadatel je povinen poplatek uhradit ve smyslu § 202a odst. 3 zákona č. 256/2004 Sb., o podnikání na kapitálovém trhu. Výše poplatku je 90 Kč. ',
    PODMINKY_P4:
        'Žadatel je povinen poskytnout centrálnímu depozitáři nezbytnou součinnost, zejména poskytnout osobní údaje nezbytné k vyřízení žádosti (včetně poskytnutí rodného čísla prostřednictvím BankID). Žadatel může být vyzván k doložení dalších údajů, zejména k doložení oprávnění výpis požadovat (např. při změně jména, apod.). Pokud žadatel neposkytne údaje potřebné k vyřízení žádosti po jejím zaplacení, nebude žádost dokončena. Dokončení žádosti můžete provést do 14 dní od zaplacení. V případě nedokončené žádosti se platba nevrací.',
    PODMINKY_P5:
        'Žadatel souhlasí s tím, že mu budou výpis z nezařazeného účtu a potvrzení o úhradě poskytnuty pouze v elektronické podobě. Tyto dokumenty si žadatel sám stáhne využitím webového odkazu během doby platnosti, která činí 30 dní. ',
    PODMINKY_P6:
        'Poskytovatelem používané platební brány je společnost ComGate Payments, a.s. Kontaktní údaje pro účely případných reklamací nebo dotazů k platbám:',

    STAV_NADPIS: 'Stav žádosti',
    STAV_PLVRAC: 'Platba byla vrácena',
    STAV_ZRUS: 'Žádost byla zrušena',
    STAV_PLZRUS: 'Platba byla zrušena. Pro pokračování je nutné platbu dokončit.',
    STAV_PLODLO: 'Platba byla odložena. Pro pokračování je nutné platbu dokončit.',
    STAV_PLZAPL_NADPIS: 'Úspěšná platba – pokračujte',
    STAV_PLZAPL:
        'Vaše žádost o službu Výpis z nezařazeného účtu k aktuálnímu datu byla spárována s platbou. Přihlaste se prostřednictvím BankID a poskytněte údaj o Vašem rodném čísle, nezbytný k vytvoření výpisu.',
    STAV_CEKA:
        'Vaše žádost o službu Výpis z nezařazeného účtu se zpracovává. Obdržíte na Vámi uvedený e-mail informaci, že služba je pro Vás připravena a můžete si stáhnout její výsledek spolu s fakturou.',
    STAV_CEKA_NU2:
        'Vaše žádost o ověření majetkového účtu se zpracovává. Obdržíte na Vámi uvedený e-mail informaci, že služba je pro Vás připravena a můžete si stáhnout její výsledek spolu s fakturou.',
    STAV_CEKA_NU:
        'Vaše žádost o Zjištění majetkového účtu v nezařazené evidenci pro účely dodatečného projednání dědictví byla spárována s platbou.',
    STAV_DUPL:
        'Vaši žádost o službu Výpis z nezařazeného účtu nemůžeme automaticky zpracovat bez dalšího upřesnění z Vaší strany. Důvodem mohou být rozdílné údaje poskytnuté prostřednictvím BankID s údaji evidovanými u Vašeho majetkového účtu v nezařazené evidenci. Vaše žádost o službu se tím neruší, nicméně může být dále zpracována jen prostřednictvím pracovníků centrálního depozitáře, kteří Vás budou kontaktovat s návrhem dalšího postupu na email, který nám byl poskytnut prostřednictvím BankID.',
    STAV_ZU_1:
        'Vámi podaná žádost o Zápis změny údajů evidovaných o majiteli nezařazeného účtu byla dokončena. Na odkazu uvedeném níže si můžete stáhnout výsledek služby a daňový doklad o zaplaceném poplatku. Vyhotovené výsledky služby budou k dispozici do ',
    STAV_ZU_2:
        'Po uplynutí této lhůty bude odkaz zneplatněn a nelze ho obnovit. Informace o zapsaných údajích můžete v budoucnu získat prostřednictvím žádosti o výpis z nezařazeného účtu.',
    STAV_ZU_3:
        'V případě, že budete požadovat výpis z nezařazeného účtu s údaji po provedené aktualizaci, můžete o něj požádat následující pracovní den.  Výpis z nezařazeného účtu vždy obsahuje osobní a adresní informace a stav na majetkovém účtu k závěrce ukončeného účetního dne.',
    STAV_ZPRAC_1:
        'Vámi požadovaný výpis z nezařazeného účtu byl dokončen. Na této stránce si můžete stáhnout výsledek služby a fakturu. Vyhotovené výstupy zde budou k dispozici do ',
    STAV_ZPRAC_2:
        'Po uplynutí této lhůty bude odkaz zneplatněn, objednávku nelze opětovně obnovit a pro vytvoření dalšího výpisu musíte zadat novou žádost o službu.',
    STAV_ZPRAC_NU_1:
        'Vámi podaná žádost o Zjištění majetkového účtu v nezařazené evidenci pro účely dodatečného projednání dědictví byla dokončena. Na této stránce si můžete stáhnout výsledek služby a fakturu. Vyhotovené výstupy zde budou k dispozici do ',
    STAV_ZPRAC_NU_2:
        'Po uplynutí této lhůty bude odkaz zneplatněn a nelze ho opakovaně obnovit. Pro vytvoření nového výstupu služby musíte podat novou žádost o službu.',
    STAV_VYPR: 'Platnost odkazu s výpisem vypršela',
    NEZNAMY_STAV: 'Neznámý stav',
    OBCHODNI_PODMINKY: 'Obchodní podmínky',

    LOREM_IPSUM:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nam fermentum, nulla luctus pharetra vulputate, felis tellus mollis orci, sed rhoncus sapien nunc eget odio.',
    DETAILLEI_LEI: 'LEI',
    DETAILLEI_LEGALNAME: 'Název společnosti',
    DETAILLEI_TRANSLITOTHERENTITYNAME: 'Anglický název společnosti',
    DETAILLEI_ADDRESS: 'Adresa sídla společnosti',
    DETAILLEI_REGISTRATIONAUTHORITYID: 'Registrován u',
    DETAILLEI_OTHERREGISTAUTHORITYID: 'Jiný rejstřík',
    DETAILLEI_REGISTAUTHORITYENTITYID: 'Identifikační číslo (IČ)',
    DETAILLEI_LEGALJURISDICTION: 'Jurisdikce',
    DETAILLEI_ENTITYCATEGORY: 'Kategorie osoby',
    DETAILLEI_LEGALFORM: 'Právní forma',
    DETAILLEI_OTHERLEGALFORM: 'Jiná právní forma',
    DETAILLEI_ENTITYSTATUS: 'Status společnosti',
    DETAILLEI_ENTITYCREATIONDATE: 'Datum založení společnosti',
    DETAILLEI_INITIALREGISTRATIONDATE: 'Datum registrace',
    DETAILLEI_LASTUPDATEDATE: 'Datum poslední aktualizace',
    DETAILLEI_REGISTRATIONSTATUS: 'Status LEI',
    DETAILLEI_ENTITYLEGALFORMCODE: 'Právní forma',
    DETAILLEI_NEXTRENEWALDATE: 'Datum příští certifikace / Platnost do',
    DETAILLEI_MANAGINGLOU: 'Vydavatel LEI',
    DETAILLEI_ENDNODEID: 'LEI',
    DETAILLEI_RELATIONSHIPTYPE: 'Typ vztahu',
    DETAILLEI_RELATIONSHIPSTATUS: 'Status',
    DETAILLEI_EXCEPTIONCATEGORY: 'Kategorie',
    DETAILLEI_EXCEPTIONREASON: 'Důvod nezveřejnění',
    DIRECT_ACCOUNTING_CONSOLIDATION_PARENT: 'Přímá mateřská společnost',
    VALIDACE_GLOBAL_INPUT: 'Položka smí obsahovat pouze číslice, písmena, speciální znaky a mezeru',
    ULTIMATE_ACCOUNTING_CONSOLIDATION_PARENT: 'Ultimátní mateřská společnost',
    LEI_GLEIF_STAV_LAPSED: 'Lapsed',
    LEI_GLEIF_STAV_MERGED: 'Merged',
    LEI_GLEIF_STAV_RETIRED: 'Retired',
    LEI_GLEIF_STAV_ANNULLED: 'Annulled',
    LEI_GLEIF_STAV_CANCELLED: 'Cancelled',
    LEI_GLEIF_STAV_TRANSFERRED: 'Transferred',
    LEI_GLEIF_STAV_PENDING_TRANSFER: 'Pending transfer',
    LEI_GLEIF_STAV_PENDING_ARCHIVAL: 'Pending archival',
    LEI_GLEIF_STAV_PENDING_VALIDATION: 'Nevedený',
    LEI_GLEIF_STAV_ISSUED: 'Issued',
    LEI_STATUS_ACTIVE: 'Active',
    LEI_STATUS_INACTIVE: 'Inactive',
    LEI_DATUM_ZMENY: 'Datum poslední změny',
    LEI_SEZNAM: 'Seznam přidělených LEI',
    LEI_SEZNAM_VYBRANYCH: 'Seznam vybraných LEI',
    HISTORIE_VYDANNYCH_LEI: 'Historie vydaných seznamů LEI',
    NEVALIDNI_LEI_VS: 'Nevalidní LEI',
    NEVALIDNI_ICO: 'Nevalidní IČO',
    DUVERNE_INFO_NEPOVINNE_ERR: 'Alespoň jeden z nepovinných parametrů musí být vyplněn',
    UDAJE_DRZITEL_LEI: 'Údaje o držiteli LEI',
    REG_UDAJE_LEI: 'Registrační údaje LEI',
    LEI_MATKY_INFO: 'Informace o mateřských společnostech',
    INFO_LEI_FOND: 'Informace o fondech',
    INFO_LEI_BRANCH: 'Informace o branch',
    REF_DATA_LEI: 'Referenční data LEI',
    UDAJE_K_DATU: 'Údaje jsou aktuálni k',
    IS_DIRECTLY_CONSOLIDATED_BY: 'Přímá mateřská společnost',
    IS_ULTIMATELY_CONSOLIDATED_BY: 'Ultimátní mateřská společnost',
    NATURAL_PERSONS: 'Fyzické osoby',
    NON_CONSOLIDATING: 'Neexistuje konsolidace',
    NON_PUBLIC: 'Nezveřejněno',
    NO_KNOWN_PERSON: 'Osoby nejsou známy',
    LEGAL_OBSTACLES: 'Zákonné překážky',
    CONSENT_NOT_OBTAINED: 'Nebyl poskytnut souhlas',
    BINDING_LEGAL_COMMITMENTS: 'Jiné právní závazky',
    DETRIMENT_NOT_EXCLUDED: 'Nelze vyloučit škodu',
    DISCLOSURE_DETRIMENTAL: 'Zveřejnění by způsobilo škodu',
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    LAPSED: 'Lapsed',
    MERGED: 'Merged',
    RETIRED: 'Retired',
    ANNULLED: 'Annulled',
    CANCELLED: 'Cancelled',
    TRANSFERRED: 'Transferred',
    PENDING_TRANSFER: 'Pending transfer',
    PENDING_ARCHIVAL: 'Pending archival',
    PENDING_VALIDATION: 'Nevedený',
    ISSUED: 'Issued',
    VYHLEDAT: 'Vyhledat',
    JINY_PRAVNI_KOD: 'Jiná právní forma',
    SLUZBA_ODKAZ: 'Odkaz na službu',
    IS_SUBFUND_OF: 'Zastřešující investiční fond (Umbrella structure)',
    IS_FEEDER_TO: 'Nadřazený investiční fond (Master-Feeder structure)',
    IS_FUND_MANAGED_BY: 'Investiční společnost (Obhospodařovatel fondu)',
    POPIS_SLUBY_TITLE: 'Vyhledávání v seznamu již přidělených LEI',
    POPIS_SLUBY_TEXT_NZ:
        'Služba umožňuje majiteli nezařazeného účtu aktualizovat osobní či adresní údaje a zapsat nebo změnit číslo bankovního účtu pro účely výplat výnosů.',
    POPIS_SLUBY_TEXT:
        'Stránka nabízí možnost vyhledávání v seznamu subjektů, jimž Centrální depozitář dosud přidělil LEI. Vyhledávat lze podle LEI, IČ a názvu společnosti.',
    NU_POPIS_STRANKY:
        'Služba umožňuje dědici, který již má ukončeno dědické řízení, zjistit, zda je v evidenci nezařazených účtů (tj. v evidenci účtů převzatých ze Střediska cenných papírů) stále veden účet pro zůstavitele, a tím mu umožnit rozhodnutí o případném podání žádosti o dodatečné projednání dědictví. Služba sděluje stav ke dni podání žádosti o službu. V nezařazené evidenci nejsou vedeny účty, na kterých nejsou evidovány žádné cenné papíry, resp. účty s nulovým zůstatkem jsou ke konci měsíce rušeny. Služba neposkytuje informace o zaknihovaných cenných papírech evidovaných na zjištěném účtu. Tyto informace lze získat teprve prostřednictvím notáře v rámci dodatečného projednání dědictví.  Žadatel je povinen uvést v žádosti zejména rodné číslo zůstavitele a spisovou značku již ukončeného dědického řízení. V probíhajícím dědickém řízení zjišťuje účet notář, včetně údajů o evidovaných cenných papírech. Službou se zjišťuje pouze účet vedený v nezařazené evidenci. Pokud byl účet zřízen účastníkem v centrální evidenci, samostatné evidenci nebo v evidencích navazujících, není tento účet službou zjišťován. Žadatel žádá o službu tak, že se identifikuje prostřednictvím bankovní identity a uhradí poplatek online platbou přes platební bránu. Žadatel je povinen před poskytnutím údajů prostřednictvím bankovní identity tyto údaje zkontrolovat, zejména poskytovanou emailovou adresu, neboť na ni obdrží potvrzení o platbě a odkaz ke stažení výsledku služby.',
    NU_POPIS_LOGIN_NADPIS:
        'Přístup k výsledku žádosti o Zjištění majetkového účtu v nezařazené evidenci pro účely dodatečného projednání dědictví',
    NU_POPIS_LOGIN_TEXT:
        'Pro stažení výsledku Vámi podané žádosti o Zjištění majetkového účtu v nezařazené evidenci pro účely dodatečného projednání dědictví je třeba se nejprve identifikovat prostřednictvím BankID.',
    NEVALIDNI_RC: 'Nevalidní rodné číslo',
    FORMULARE_RODNE_CISLO: 'Rodné číslo',
    RC_UZIVATELE: 'RČ zůstavitele',
    SPISOVA_ZNACKA: 'Spisová značka (Č.j.) dědického řízení',
    SPISOVA_ZNACKA_KRATKA: 'Č.j. dědického řízení',
    ADRESA_FAKTURACANI: 'Fakturační adresa',
    ULICE_CP: 'Ulice a č. p.',
    MESTO: 'Město',
    PSC: 'PSČ',
    NU_KROKY_1:
        'Centrální depozitář cenných papírů poskytne na žádost dědice, který již má ukončeno dědické řízení, informaci, zda v evidenci nezařazených účtů (tj. v evidenci účtů převzatých ze Střediska cenných papírů) je stále veden účet pro zůstavitele. Účelem služby je umožnit dědici rozhodnutí o případném podání žádosti o dodatečné projednání dědictví. Služba sděluje stav ke dni podání žádosti o službu.',
    NU_KROKY_2:
        'Podmínkou poskytnutí služby je řádné podání žádosti, identifikace prostřednictvím bankovní identity (BankID) a uhrazení poplatku za tuto službu předem. Žadatel je povinen v žádosti uvést rodné číslo zůstavitele a spisovou značku ukončeného dědického řízení.',
    NU_KROKY_3:
        'Poplatek lze uhradit pouze prostřednictvím platební brány použitím spotřebitelské platební karty vydané v Evropské Unii nebo pomocí platebních tlačítek. Žadatel je povinen uhradit poplatek i v případě, že žádný majetkový účet v evidenci nezařazených účtů na jméno zůstavitele veden není. Výše poplatku je 70 Kč.',
    NU_KROKY_4:
        'Žadatel je povinen poskytnout centrálnímu depozitáři nezbytnou součinnost, zejména poskytnout osobní údaje nezbytné k vyřízení žádosti. Žadatel může být vyzván k doložení dalších údajů, zejména k doložení oprávnění službu požadovat (např. usnesení o dědictví). Pokud žadatel neposkytne údaje potřebné k vyřízení žádosti po jejím zaplacení, nebude žádost dokončena. V případě nedokončené žádosti se platba nevrací.',
    NU_KROKY_5:
        'Žadatel souhlasí s tím, že mu budou informace o nezařazeném účtu a potvrzení o úhradě poskytnuty pouze v elektronické podobě. Tyto dokumenty si žadatel sám stáhne využitím webového odkazu během doby platnosti, která činí 30 dní.',
    NU_KROKY_6:
        'Poskytovatelem používané platební brány je společnost ComGate Payments, a.s. Kontaktní údaje pro účely případných reklamací nebo dotazů k platbám:',
    NU_PODMINKY_1: 'Podání žádosti s identifikací žadatele prostřednictvím BankID',
    NU_PODMINKY_2: 'Poskytnutí souhlasu s podmínkami služby',
    PSC_ERROR: 'Nevalidní PSČ',
    NU_PODMINKY_3: 'Zaplacení poplatku ve výši 70 Kč',
    NU_PODMINKY_4: 'Uvedení rodného čísla zůstavitele',
    NU_PODMINKY_5: 'Uvedení spisové značky(č.j.) ukončeného dědického řízení',
    NU_PODMINKY_6: 'Stažení výsledku služby a faktury po opětovné identifikaci žadatele prostřednictvím BankID',
    TELEFON_ZADATELE: 'Telefon žadatele',
    EMAIL_ZADATELE: 'E-mail žadatele',
    RC_ZADATELE: 'Rodné číslo zůstavitele (zemřelého)',
    ZJISTENI_PODMINKA: 'zjištění majetkového účtu v nezařazené evidenci pro účely dodatečného projednání dědictví',
    UPOZORNENI: 'Upozornění',
    ANO: 'Ano',
    NE: 'Ne',
    VYBERTE_PLACEHOLDER: 'Vyberte...',
    '': ''
};
